export default __webpack_public_path__ + "static/media/ad.dfbef31b.png";